import React, { useContext } from "react";
import { Paper, Text, Group, Anchor, SimpleGrid } from "@mantine/core";
import { observer } from "mobx-react";
import { CURRENCIES } from "../helpers/currencies";
import { SatoshiConverterStoreContext } from "../stores/SatoshiConverterStore";

const CurrencyNav: React.FC = observer(() => {
  const store = useContext(SatoshiConverterStoreContext);

  return (
    <Paper
      p="lg"
      radius="md"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.08)",
      }}
    >
      <Text c="white" fw={500} mb="sm" size="sm">
        {store.strings.convertToOtherCurrencies}
      </Text>
      <SimpleGrid cols={{ base: 2, xs: 3, sm: 4 }} spacing="xs">
        {CURRENCIES.map((c) => (
          <Anchor
            key={c.code}
            href={`/${c.slug}`}
            size="xs"
            c={c.code === store.currencyCode ? "orange" : "dimmed"}
            fw={c.code === store.currencyCode ? 700 : 400}
            underline="hover"
            style={{ fontFamily: "courier-prime, monospace" }}
          >
            {c.code.toUpperCase()} — {c.symbol}
          </Anchor>
        ))}
      </SimpleGrid>
    </Paper>
  );
});

export default CurrencyNav;
